import { render, staticRenderFns } from "./TraxNotificationTopMenu.vue?vue&type=template&id=171606ca"
import script from "./TraxNotificationTopMenu.vue?vue&type=script&lang=js"
export * from "./TraxNotificationTopMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports